import { Link } from 'react-router-dom';
import { Button } from '../../../../../ui/input/Button';
import { Box } from '../../../../../ui/layout/Box';
import { Flex } from '../../../../../ui/layout/Flex';
import { Typography } from '../../../../../ui/typography/Typography';
import { useIsMobile } from '../../../../../utils/getIsMobile';
import { useTranslation } from '../../../../../utils/useTranslation';
import { AdvertisingCatalogInfoCardProps } from './types';

export const AdvertisingCatalogInfoCard: React.FC<AdvertisingCatalogInfoCardProps> = ({
    title,
    description,
    url,
    children,
    onClick,
}) => {
    const t = useTranslation();
    const isMobile = useIsMobile();

    if (isMobile === null) {
        return null;
    }

    return (
        <Box width={isMobile ? '100%' : '300px'}>
            {isMobile ? null : children}
            <Flex
                background="var(--control-tertiary-background)"
                borderRadius={3}
                width="100%"
                mt={isMobile ? 0 : '-70px'}
                p={2}
                spacing={2}
            >
                {isMobile ? null : <Box width="100%" height="44px" />}
                <Flex width="100%" direction="row" spacing={2}>
                    {isMobile ? children : null}
                    <Flex width="100%">
                        <Typography variant="title3" weight="bold">
                            {title}
                        </Typography>
                        <Typography variant="body">{description}</Typography>
                    </Flex>
                </Flex>
                <Flex width="100%" spacing={1}>
                    <Button
                        size={isMobile ? 'm' : 'l'}
                        color="primary"
                        width="100%"
                        as={Link}
                        to={url}
                    >
                        {t('Выбрать')}
                    </Button>
                    <Button
                        size={isMobile ? 'm' : 'l'}
                        color="secondary"
                        width="100%"
                        onClick={onClick}
                    >
                        {t('Как это работает?')}
                    </Button>
                </Flex>
            </Flex>
        </Box>
    );
};
